/**
 * @fileOverview Z Axis
 */
export var ZAxis = function ZAxis() {
  return null;
};
ZAxis.displayName = 'ZAxis';
ZAxis.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/recharts/es6/cartesian/ZAxis.js
// module id = null
// module chunks = 